import React from 'react';

const About = () => {
  return (
    <div className="px-4 md:px-12 lg:px-24 py-24">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl tracking-tighter mb-12" data-testid="about-title">
          Nosotros
        </h1>
        
        <div className="space-y-8 text-white/80 leading-relaxed">
          <p className="text-lg">
            Somos una plataforma premium de moda de lujo dedicada a ofrecer las mejores marcas internacionales y piezas exclusivas.
          </p>
          
          <p>
            Nuestra selección cuidadosamente curada incluye las últimas tendencias y clásicos atemporales de las casas de moda más prestigiosas del mundo.
          </p>
          
          <p>
            Cada producto que ofrecemos pasa por un riguroso proceso de verificación para garantizar su autenticidad y calidad excepcional.
          </p>
          
          <div className="border-t border-white/10 pt-12 mt-12">
            <h2 className="font-['Playfair_Display'] text-2xl tracking-tighter mb-6">Nuestra Misión</h2>
            <p>
              Democratizar el acceso a la moda de lujo, ofreciendo una experiencia de compra excepcional y personalizada para cada cliente.
            </p>
          </div>
          
          <div className="border-t border-white/10 pt-12 mt-12">
            <h2 className="font-['Playfair_Display'] text-2xl tracking-tighter mb-6">Compromiso con la Calidad</h2>
            <p>
              Trabajamos directamente con distribuidores autorizados y verificamos cada pieza para asegurar que nuestros clientes reciban productos auténticos de la más alta calidad.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
